import { render, staticRenderFns } from "./CameraCard.vue?vue&type=template&id=6a206435&scoped=true"
import script from "./CameraCard.vue?vue&type=script&lang=js"
export * from "./CameraCard.vue?vue&type=script&lang=js"
import style0 from "./CameraCard.vue?vue&type=style&index=0&id=6a206435&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a206435",
  null
  
)

export default component.exports